import { render } from "./MisBuzones.vue?vue&type=template&id=2484c233&scoped=true"
import script from "./MisBuzones.vue?vue&type=script&lang=js"
export * from "./MisBuzones.vue?vue&type=script&lang=js"

import "./MisBuzones.vue?vue&type=style&index=0&id=2484c233&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2484c233"]])

export default __exports__